<template>
  <v-card flat>
    <v-card-text>
      <v-row justify="center" class="my-8">
        <v-col md="8">
          <p class="nl2br" v-text="fields.reports.proposal.additional_notes" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'tabAdditionalNotes',
  props: ['fields'],
  data() {
    return {
      showWindow: false,
    };
  },
};
</script>
